import { render, staticRenderFns } from "./WarringtonCity.vue?vue&type=template&id=71647d76&scoped=true&"
import script from "./WarringtonCity.vue?vue&type=script&lang=js&"
export * from "./WarringtonCity.vue?vue&type=script&lang=js&"
import style0 from "./WarringtonCity.vue?vue&type=style&index=0&id=71647d76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71647d76",
  null
  
)

export default component.exports